import React, { useEffect } from "react";
import WidgetForIframe from "./WidgetForIframe";
import WidgetForJS from "./WidgetForJS";
import platform from "Pub/js/platform";
const { PubSub } = platform;
/**
 * 小部件生成器
 * @param {Object} appOption 小部件描述信息
 * @param {Object} style 小部件容器
 */
const CreaterForWidget = ({ appOption, style, isScale, needRecordMounted, ...others }) => {
    let { cardid, target_path } = appOption;
    const originalPath = target_path && target_path.split("?")[0];
    const isJs = new RegExp(/js$/).test(originalPath);
    useEffect(() => {
        if (!isJs) { // iframe类型的不用等
            handleWidgetMounted();
        }
    }, []);

    const handleWidgetMounted = () => {
        needRecordMounted && PubSub.publish("linkageWidgetMounted", cardid);
    }

    return VerifyURL(appOption, others, isJs ? handleWidgetMounted : null);
};

/**
 * URL 验证是否使用 js 结尾
 * @param {String} path 小部件原始路径
 */
const VerifyURL = (appOption, others, handleJsWidgetMounted) => {
    let { cardid, name, target_path, pk_app_group, appcode } = appOption;
    const commonProps = {
        name: name,
        groupId: pk_app_group,
        cardId: cardid,
        src: target_path,
        appcode: appcode,
        width: appOption.width,
        height: appOption.height,
    }
    if (handleJsWidgetMounted) {
        return (
            <WidgetForJS {...commonProps} {...others} onWidgetMounted={handleJsWidgetMounted} />
        );
    } else {
        return (
            <WidgetForIframe {...commonProps}/>
        );
    }
};
export default CreaterForWidget;
